// src/components/ui/Card.jsx
import React from "react";

export default function Card({ className = "", children }) {
  return (
    <div className={`bg-white border border-[#e7eaef] rounded-2xl shadow-none ${className}`}>
      {children}
    </div>
  );
}
